<template>
	<r-standard-modal-form @closeModal="$emit('closeModal')">
		<span slot="title">Edit View Name</span>
		<div slot="body" class="add-sheet-view-body">
			<div>
				<div class="input-header">New View Name</div>
				<div class="name-container">
					<input 
						class="name-input-field"
						ref="tabNameRef"
						v-model="tabName"
						placeholder="View Name"
						@keyup.enter.stop.prevent="changeSheetViewName"
						@keydown.esc.stop.prevent="$emit('closeModal')"
					/>
				</div>
			</div>
			<r-button theme="dark-blue" fullWidth class="save-button" @click="changeSheetViewName">
				Save
			</r-button>
			<div class="cancel-button">
				<span class="cancel-button-text" @click="$emit('closeModal')">Cancel</span>
			</div>
		</div>
	</r-standard-modal-form>
</template>

<script>

// TODO: get choice array from imported Tab Type file
import CloudStore from 'js/cloudstore/cloudstore';

// using this below to send into the selectfield because it doesn't like using Null as a GUID.
const ADD_NEW_SVG =  'lkasjdjhgtlkasjh';

export default {
	name: 'edit-sheet-view-name-modal',
	$pubsub:{
		sheetViews:{
			
		}
	},
	data(){
		return {
			tabName: null,
		}
	},
	mounted(){
		const rvSelf = this;

		this.tabName = this.sheetView.title;

		const focusable = this.$el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
		if(focusable[0] && focusable[0].focus){
			focusable[0].focus();
		}

		rvSelf.$nextTick(function afterTick(){
			rvSelf.$refs.tabNameRef.select();
		});
	},
	props:{
		sheetView:{
			required: true,
			type: Object,
		},
	},
	computed:{

	},
	methods:{
		changeSheetViewName(){
			const rvSelf = this;

			if(rvSelf.tabName){
				rvSelf.sheetView.title = rvSelf.tabName;
			}

			rvSelf.$nextTick(function afterTick(){
				rvSelf.$emit('closeModal');
			});
		},
	}

}

</script>

<style scoped lang="scss">

.add-sheet-view-body{
	width: 100%;

	.input-header{
		font-family: $rvFontFamily;
		font-weight: 600;
		font-size: 13px;
		line-height: 19px;
		letter-spacing: 0.01em;
		color: $p-color-grey-400;
		margin-bottom: 6px;
		display: flex;
		align-items: center;
	}

	.name-container{
		display: flex;
		margin-bottom: 18px;

		.name-input-field{
			font-family: $rvFontFamily;
			font-weight: 500;
			font-size: 14px;
			line-height: 20px;
			outline: none;
			letter-spacing: 0.15px;
			color: $p-color-grey-600;
			padding: 10px 9px;
			border: 1px solid $p-color-grey-300;
			width: 100%;

			&:focus{
				border: 1px solid $p-color-grey-600;
			}
		}
	}
}

.save-button{
	width: 100%;
	margin-bottom: 24px;
}

.cancel-button{
	@include flex(row, center, center);

	.cancel-button-text{
		font-weight: 600;
		font-size: 14px;
		line-height: 21px;
		text-align: center;
		letter-spacing: 0.01em;
		color: $p-color-grey-500;

		@include clickable;
	}
}

.footer-text{
	margin: 24px 0;

	font-weight: normal;
	font-size: 13px;
	line-height: 20px;
	/* or 154% */

	letter-spacing: 0.1px;

	color: #9CA3B2;
}

</style>